import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-add-bank-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './confirm-add-bank-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirm-add-bank-dialog.component.scss']
})
export class ConfirmAddBankDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmAddBankDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onClose(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
